import React, { useState } from 'react';
import { toast } from 'sonner';
import { X as XIcon, Loader2 } from 'lucide-react';
import { PorterAvatar, errMsg, withOverride } from './porterUi';

export const ReplacementPicker = ({ job, replacing, authFetch, onClose, onDone }) => {
  const [list, setList] = useState(null);
  const [busy, setBusy] = useState(null);
  React.useEffect(() => {
    authFetch('get', `/admin/crew/replacements?quote_id=${job.id}`).then(({ data }) => setList(data.porters)).catch((e) => toast.error(errMsg(e)));
  }, [authFetch, job.id]);
  React.useEffect(() => { const k = (e) => e.key === 'Escape' && onClose(); window.addEventListener('keydown', k); return () => window.removeEventListener('keydown', k); }, [onClose]);
  const pick = async (p) => {
    setBusy(p.id);
    try {
      await withOverride((override_reason) => authFetch('post', '/admin/crew/assign', { porter_id: p.id, quote_id: job.id, replace_assignment_id: replacing?.assignment.id || null, override_reason }));
      toast.success(replacing ? `${p.name} replaces ${replacing.porter.name}.` : `${p.name} assigned to #${job.ref}.`);
      onDone();
      onClose();
    } catch (e) { if (!e.cancelled) toast.error(errMsg(e)); } finally { setBusy(null); }
  };
  return (
    <div className="fixed inset-0 z-[70] bg-black/50 flex items-end sm:items-center justify-center" onClick={onClose} data-testid="replacement-modal">
      <div onClick={(e) => e.stopPropagation()} className="w-full sm:max-w-md bg-white rounded-t-2xl sm:rounded-xl p-4 max-h-[80vh] overflow-y-auto">
        <div className="flex items-center justify-between mb-2">
          <h3 className="font-display text-lg font-extrabold text-[color:var(--mv-navy)]">{replacing ? `Replace ${replacing.porter.name}` : 'Add a porter'} · #{job.ref}</h3>
          <button type="button" onClick={onClose} className="w-10 h-10 inline-flex items-center justify-center text-slate-500" aria-label="Close"><XIcon className="w-5 h-5" /></button>
        </div>
        <p className="text-xs text-slate-500 mb-3">Only porters who are free at {job.booking?.time} on {job.booking?.date} are shown.</p>
        {!list ? <Loader2 className="w-5 h-5 animate-spin" /> : list.length === 0 ? (
          <div className="text-sm text-slate-500" data-testid="replacement-empty">No available porters for this time.</div>
        ) : (
          <div className="space-y-2" data-testid="replacement-list">
            {list.map(p => (
              <button key={p.id} type="button" onClick={() => pick(p)} disabled={!!busy} className="w-full min-h-[48px] flex items-center gap-3 px-3 py-2 rounded-md border border-slate-200 hover:border-[color:var(--mv-orange)] text-left" data-testid={`replacement-option-${p.id}`}>
                <PorterAvatar p={p} />
                <div className="flex-1 min-w-0">
                  <div className="font-bold text-[color:var(--mv-navy)] truncate">{p.name}</div>
                  <div className="text-xs text-slate-500 truncate">{p.phone}{p.skills.length ? ` · ${p.skills.join(', ')}` : ''}</div>
                </div>
                {busy === p.id && <Loader2 className="w-4 h-4 animate-spin" />}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
